export var handleModNames = function handleModNames() {
  var mods = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var selectedKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "selectedOptions";
  var optionKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "optionName";
  var returnValue = mods.map(function (mod) {
    if (mod[selectedKey]) {
      return mod[selectedKey].map(function (option) {
        return option ? option[optionKey] : null;
      });
    } else {
      return null;
    }
  }).flat().filter(function (el) {
    return el != null;
  }).filter(function (mod) {
    return !mod.toLowerCase().includes("side") || mod.toLowerCase().includes("sunny");
  });
  return returnValue;
};